import React, { useEffect, useState } from "react";
import styles from "./styles/LicencePlate.module.css";
import "../../../fonts/GlNummernschild/GlNummernschildEng-XgWd.ttf";
import "../../../fonts/GlNummernschild/GlNummernschildMtl-LrZZ.ttf";
import LicensePlateDetect from "../licence_plate_detect/LicencePlateDetect";
import Spinner from "../spinner/Spinner";
/**
 * Licence plate component for German plates
 * the flag svg is embeded in the jsx
 */
const LicencePlate = ({ country, number, margin, base64Image }) => {
    const [croppedPlate, setCroppedPlate] = useState(undefined);

    useEffect(() => {
        if (!base64Image) {
            setCroppedPlate(null);
        } else {
            setCroppedPlate(undefined);
        }
    }, [base64Image]);

    const numberStyle = () => {
        if (!number) return;
        const charsCount = number.length;
        switch (charsCount) {
            case 8:
                return styles.number_8chars;
            case 9:
                return styles.number_9chars;
            default:
                return "";
        }
    };
    return (
        <>
            <section
                className={`${styles.main_plate_container} flex-container`}
                style={{ margin: margin }}
            >
                <div className={`${styles.plate_container} flex-container`}>
                    {country ? (
                        <div
                            className={`${styles.plate_flag_container} v-flex-container`}
                        >
                            <div
                                className={`${styles.flag_logo_container} flex-container`}
                            >
                                <svg viewBox="0 0 448 443" height={20}>
                                    <use href="#euroFlag"></use>
                                </svg>
                            </div>
                            <div
                                className={`${styles.flag_country} flex-container`}
                            >
                                {country}
                            </div>
                        </div>
                    ) : (
                        <></>
                    )}
                    <div
                        className={`${
                            country
                                ? styles.plate_number
                                : styles.plate_number_default
                        } ${numberStyle()} ${
                            !country ? styles.no_country : ""
                        } flex-container`}
                    >
                        {croppedPlate === undefined && (
                            <LicensePlateDetect
                                key={base64Image}
                                base64Image={base64Image}
                                onDetect={setCroppedPlate}
                            />
                        )}

                        {croppedPlate === undefined ? (
                            <Spinner small />
                        ) : croppedPlate ? (
                            <img src={croppedPlate} alt="Plate" />
                        ) : (
                            number
                        )}
                        {/* {number} */}
                    </div>
                </div>
            </section>
            {/* The Euro flag svg */}
            <svg
                className={`display-non`}
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
            >
                <symbol
                    id="euroFlag"
                    data-name="euroFlag"
                    viewBox="0 0 448 443"
                >
                    <polygon
                        fill="#fc0"
                        strokeWidth="0"
                        points="224 14.5 224 14.3 224 14.5 217.2 35.1 195.5 35.1 213.2 47.9 206.4 68.6 206.4 68.7 206.5 68.6 206.5 68.6 206.7 68.3 224 55.9 241.3 68.3 241.5 68.6 241.5 68.6 241.6 68.7 241.6 68.6 234.8 47.9 252.5 35.1 230.8 35.1 224 14.5"
                    />
                    <polygon
                        fill="#fc0"
                        strokeWidth="0"
                        points="230.8 395.1 224 374.5 224 374.3 224 374.5 217.2 395.1 195.5 395.1 213.2 407.9 206.4 428.6 206.4 428.7 206.5 428.6 206.5 428.6 206.7 428.3 224 415.9 241.3 428.3 241.5 428.6 241.5 428.6 241.6 428.7 241.6 428.6 234.8 407.9 252.5 395.1 230.8 395.1"
                    />
                    <polygon
                        fill="#fc0"
                        strokeWidth="0"
                        points="61.3 248.3 61.5 248.6 61.5 248.6 61.6 248.7 61.6 248.6 54.8 227.9 72.5 215.1 50.8 215.1 44 194.5 44 194.3 44 194.5 37.2 215.1 15.5 215.1 33.2 227.9 26.4 248.6 26.4 248.7 26.5 248.6 26.5 248.6 26.7 248.3 44 235.9 61.3 248.3"
                    />
                    <polygon
                        fill="#fc0"
                        strokeWidth="0"
                        points="134 38.6 134 38.4 134 38.6 127.2 59.2 105.5 59.2 123.2 72 116.4 92.8 116.4 92.9 116.5 92.8 116.5 92.8 116.7 92.5 134 80.1 151.3 92.5 151.5 92.8 151.5 92.8 151.6 92.9 151.6 92.8 144.8 72 162.5 59.2 140.8 59.2 134 38.6"
                    />
                    <polygon
                        fill="#fc0"
                        strokeWidth="0"
                        points="68.1 104.5 68.1 104.3 68.1 104.3 68.1 104.3 68.1 104.3 68.1 104.5 61.3 125.1 39.6 125.1 57.3 137.9 50.5 158.6 50.5 158.7 50.6 158.6 50.6 158.6 50.8 158.3 68.1 145.9 85.4 158.3 85.6 158.6 85.6 158.6 85.7 158.7 85.7 158.6 78.9 137.9 96.6 125.1 74.9 125.1 68.1 104.5"
                    />
                    <polygon
                        fill="#fc0"
                        strokeWidth="0"
                        points="74.9 305.1 68.1 284.5 68.1 284.3 68.1 284.3 68.1 284.3 68.1 284.3 68.1 284.5 61.3 305.1 39.6 305.1 57.3 317.9 50.5 338.6 50.5 338.7 50.6 338.6 50.6 338.6 50.8 338.3 68.1 325.9 85.4 338.3 85.6 338.6 85.6 338.6 85.7 338.7 85.7 338.6 78.9 317.9 96.6 305.1 74.9 305.1"
                    />
                    <polygon
                        fill="#fc0"
                        strokeWidth="0"
                        points="140.8 371 134 350.3 134 350.1 134 350.3 127.2 371 105.5 371 123.2 383.8 116.4 404.5 116.4 404.6 116.5 404.5 116.5 404.5 116.7 404.2 134 391.8 151.3 404.2 151.5 404.5 151.5 404.5 151.6 404.6 151.6 404.5 144.8 383.8 162.5 371 140.8 371"
                    />
                    <polygon
                        fill="#fc0"
                        strokeWidth="0"
                        points="410.8 215.1 404 194.5 404 194.3 404 194.5 397.2 215.1 375.5 215.1 393.2 227.9 386.4 248.6 386.4 248.7 386.5 248.6 386.5 248.6 386.7 248.3 404 235.9 421.3 248.3 421.5 248.6 421.5 248.6 421.6 248.7 421.6 248.6 414.8 227.9 432.5 215.1 410.8 215.1"
                    />
                    <polygon
                        fill="#fc0"
                        strokeWidth="0"
                        points="296.4 92.8 296.4 92.9 296.5 92.8 296.5 92.8 296.7 92.5 314 80.1 331.3 92.5 331.5 92.8 331.5 92.8 331.6 92.9 331.6 92.8 324.8 72 342.5 59.2 320.8 59.2 314 38.6 314 38.4 314 38.6 307.2 59.2 285.5 59.2 303.2 72 296.4 92.8"
                    />
                    <polygon
                        fill="#fc0"
                        strokeWidth="0"
                        points="362.3 158.6 362.3 158.7 362.4 158.6 362.4 158.6 362.6 158.3 379.9 145.9 397.2 158.3 397.4 158.6 397.4 158.6 397.5 158.7 397.5 158.6 390.7 137.9 408.4 125.1 386.7 125.1 379.9 104.5 379.9 104.3 379.9 104.5 373.1 125.1 351.4 125.1 369.1 137.9 362.3 158.6"
                    />
                    <polygon
                        fill="#fc0"
                        strokeWidth="0"
                        points="386.7 305.1 379.9 284.5 379.9 284.3 379.9 284.5 373.1 305.1 351.4 305.1 369.1 317.9 362.3 338.6 362.3 338.7 362.4 338.6 362.4 338.6 362.6 338.3 379.9 325.9 397.2 338.3 397.4 338.6 397.4 338.6 397.5 338.7 397.5 338.6 390.7 317.9 408.4 305.1 386.7 305.1"
                    />
                    <polygon
                        fill="#fc0"
                        strokeWidth="0"
                        points="320.8 371 314 350.3 314 350.1 314 350.3 307.2 371 285.5 371 303.2 383.8 296.4 404.5 296.4 404.6 296.5 404.5 296.5 404.5 296.7 404.2 314 391.8 331.3 404.2 331.5 404.5 331.5 404.5 331.6 404.6 331.6 404.5 324.8 383.8 342.5 371 320.8 371"
                    />
                </symbol>
            </svg>
        </>
    );
};

export default LicencePlate;
